import Select from './select/ContractInputAgreementSelect';
import Text from './text/ContractInputAgreementText';
import Share from './shares/ContractInputAgreementShares';
import DefaultShare from './defaultShare/ContractInputAgreementDefaultShare';
import Paragraph from './paragraph/ContractInputAgreementParagraph';

export default { Text, Select, Share, DefaultShare, Paragraph };
